import { render, staticRenderFns } from "./button-about.vue?vue&type=template&id=a1ad454e&scoped=true&"
import script from "./button-about.vue?vue&type=script&lang=js&"
export * from "./button-about.vue?vue&type=script&lang=js&"
import style0 from "./button-about.vue?vue&type=style&index=0&id=a1ad454e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ad454e",
  null
  
)

export default component.exports